import { render, staticRenderFns } from "./Visualizar-colaborador.vue?vue&type=template&id=fb0a3394&"
import script from "./Visualizar-colaborador.vue?vue&type=script&lang=js&"
export * from "./Visualizar-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./Visualizar-colaborador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports